import axios from 'axios';

function getUrl() {
  // return process.env.REACT_APP_CHART_URL;
  // return 'http://localhost:3014'
  // return 'http://103.90.86.250:3014'
  return 'https://dalalstreet.systemxlite.com'
}

const axiosOrder = axios.create({
  baseURL: process.env.REACT_APP_DALALSTREET_BACKEND_URL,
})
export default axiosOrder;



// WEBPACK FOOTER //
// ./src/dalalstreet/src/axios.ts